import {
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_BEGIN,
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_SUCCESS,
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_FAILURE,
  DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
export function updateCollectionForDirectus(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_BEGIN,
    });
    const { version, projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/directus/update-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_SUCCESS,
            data: res,
          });
          toast.success('Collection Updated Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_FAILURE,
            data: { error: err },
          });
          toast.error(`Failed: to Update Collection`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateCollectionForDirectusError() {
  return {
    type: DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_BEGIN:
      return {
        ...state,
        updateCollectionForDirectusPending: true,
        updateCollectionForDirectusError: null,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_SUCCESS:
      return {
        ...state,
        updateCollectionForDirectusPending: false,
        updateCollectionForDirectusError: null,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_FAILURE:
      return {
        ...state,
        updateCollectionForDirectusPending: false,
        updateCollectionForDirectusError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_FOR_DIRECTUS_DISMISS_ERROR:
      return {
        ...state,
        updateCollectionForDirectusError: null,
      };

    default:
      return state;
  }
}
